import React from 'react';

import { Input, Select, Tooltip, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import { graphql } from 'react-apollo';

import getCiudades from '../../../graphql/querys/organismos/getCiudades.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

import _ from 'lodash';
@graphql(getCiudades)
class FormDireccionReal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      id_TipoCertificacion: '',
      cantidad: 0,
      existeVenta: false,
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        // console.log(this.props);
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones = ciudad => {
    return (
      <Option key={ciudad._id} value={ciudad._id}>
        {ciudad.nombre}
      </Option>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaCiudades = this.props.data.getCiudades;
    if (listaCiudades) {
      var opciones = _.map(listaCiudades, this.crearOpciones);
    }
    // let listaTiposCertificaciones = this.props.data.getTipoCertificaciones;
    // if (listaTiposCertificaciones) {
    //   var opciones = _.map(listaTiposCertificaciones, this.crearOpciones);
    // }

    return (
      <div>
        <h1 className="tituloForm">Datos extras del Contraventor</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Localidad en el Expte.
                <Tooltip title="Localidad donde esta radicado actualmente">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('localidad', {
              rules: [
                {
                  message: 'Por favor, ingresar la localidad!',
                  whitespace: true,
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 400 }}
                placeholder="Seleccione una localidad"
                optionFilterProp="children"
                onChange={this.props.handleChange}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Calle en el Expte.
                <Tooltip title="Calle del domiclio real del contraventor">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('calle', {
              rules: [
                {
                  message: 'Por favor, ingresar la calle!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Numero en el Expte.
                <Tooltip title="Numero del domicilio donde declara que esta la persona">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('numero', {
              rules: [
                {
                  message: 'Por favor, ingresar el numero!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Obs. de la Direccion en el Expte.
                <Tooltip title="Observacion extra de la direccion real">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacion', {
              rules: [
                {
                  message: 'Por favor, ingresar la direccion!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      calle: Form.createFormField({
        value: props.datos ? props.datos.direccion_calle : '',
      }),
      numero: Form.createFormField({
        value: props.datos ? props.datos.direccion_numero : 0,
      }),
      observacion: Form.createFormField({
        value: props.datos ? props.datos.direccion_otro : '',
      }),
      localidad: Form.createFormField({
        value:
          props.datos && props.datos.localidad ? props.datos.localidad._id : '',
      }),
    };
  },
})(FormDireccionReal);
